import React, { useMemo } from "react"
import { Business } from '@mui/icons-material'
import { Skeleton } from '@mui/material'

export default function CompanyLogo({ image, website, ticker, size = 94}) {
    const checkIfValidImage = (url) => /\.(jpeg|jpg|png|gif)\b/i.test(url)

    const imgSize = `${size}px`

    const logo = useMemo(() => {
        if(typeof image === 'undefined') return <Skeleton variant="rect" width={size} height={size} />
        return (
        <a href={website ?? null} target="_blank" rel="noreferrer">
            {checkIfValidImage(image) 
                ? <img style={{maxWidth: imgSize, maxHeight: imgSize, borderRadius:'4px'}} src={image} alt={`${ticker} logo"`}/>
                :<Business color='textPrimary' sx={{width: imgSize, height: imgSize}}/>}
        </a> )
    }, [image, ticker, imgSize, website, size])

    return (logo)
}
